// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CredentialVerificationStatusSchema } from '../inputTypeSchemas/CredentialVerificationStatusSchema'

/////////////////////////////////////////
// CREDENTIAL VERIFICATION SCHEMA
/////////////////////////////////////////

export const CredentialVerificationSchema = z.object({
  status: CredentialVerificationStatusSchema,
  lastError: z.string().nullable(),
  lastAttemptAt: z.coerce.date().nullable(),
  verifiedAt: z.coerce.date().nullable(),
})

export type CredentialVerification = z.infer<typeof CredentialVerificationSchema>

export default CredentialVerificationSchema;
